import { useEffect, useRef } from "react";

import SearchInput from "common/components/SearchInput";
import useLeadsSearchParams from "common/hooks/useLeadsSearchParams";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { LeadsSearchParams, SelectedFacetParam } from "common/types";

export default function Heading({
  setSearchParams,
  searchParams,
  keywordInputValue,
  setKeywordInputValue,
}: {
  searchParams: LeadsSearchParams<SelectedFacetParam>;
  setSearchParams: (
    searchParams: Partial<LeadsSearchParams<SelectedFacetParam>>,
  ) => void;
  keywordInputValue: string;
  setKeywordInputValue: (keywordInputValue: string) => void;
}) {
  const isDesktop = useTwBreakpoint("lg");
  const timeoutRef = useRef(null);

  const { setSearchParam } = useLeadsSearchParams(
    searchParams,
    setSearchParams,
  );

  useEffect(() => {
    if (keywordInputValue) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(
        () => setSearchParam("keywords", keywordInputValue),
        800,
      );
      return () => clearTimeout(timeoutRef.current);
    }
    setSearchParam("keywords", keywordInputValue);
  }, [keywordInputValue]);

  return (
    <SearchInput
      placeholder="Search Leads"
      onChange={(e) => setKeywordInputValue(e.target.value)}
      value={keywordInputValue}
      onClear={() => setKeywordInputValue("")}
      className="md:max-w-80"
      variant={isDesktop ? "sm" : "md"}
    />
  );
}
